module.exports = __webpack_public_path__ + "media/ja_jp_s2_Fumiko.c886a333.mp3";